import dayjs from 'dayjs';
import API from './../../API.js';

export default async function getAll(parameters) {
  parameters = {
    ...parameters,
    perPage: parameters.perPage || 15,
    from: parameters.startTime ? dayjs(parameters.startTime).format('YYYY-MM-DD HH:mm:ss') : null,
  };
  if (parameters.employee) {
    parameters.employee_id = parseInt(parameters.employee);
  }
  const result = await API.get('scan-result-group', {
    params: parameters,
  });
  return {data: result.data.data, lastPage: result.data.meta.last_page};
}
